(function (window, undefined) {
  'use strict';
  var scripts = document.getElementsByTagName('script');
  var baseRoot = 'CBL-FINANZA-MF';
  for (var el in scripts) {
    if (scripts[el].src && scripts[el].src.indexOf('FINANZA') > -1) {
      baseRoot = scripts[el].src.split('/')[3];
    }
  }
  angular.module('cbl.finanza.mf').constant('FIN_CONSTANTS', {
    ABILITAZIONI: {
      ACCETTA_RACCOMANDAZIONE: 'ACCETTARACCOMAN',
      VALUTA_PRATICA: 'VALUTAPRATICA',
      VISUALIZZA_PARAMETRI_BLOCCATI: 'visibilita_parametri_bloccati',
      FILTRA_RACCOMANDAZIONI: 'filtra_raccomandazioni',
      TABELLA_RACCOMNDAZIONI_ESTESA: 'tabella_raccomandazioni_estesa',
      COPIA_RACCOMANDAZIONE: 'copia_raccomandazione',
      VERIFICA_PROPOSTE: 'verifica_proposte',
      MIFID: 'MifidAlertType',
      ESG_CONSULENZA_ATTIVA: 'EsgConsulenzaAttiva',
      MODALITA_ESPOSIZIONE_ESG_STRUMENTO: 'ModalitaEsposzioneEsgStrumento',
      ATTIVA_LIQUIDITA_AGGIUNTIVA: 'AttivaLiquiditaAggiuntiva',
      RICONTRATTUALIZZAZIONE: 'Ricontrattualizzazione'
    },
    OPERAZIONI: {
      RIMODULAZIONE_PIANO: 'P',
      ACQUISTO: 'A',
      VENDITA: 'D',
      SWITCH: 'S'
    },
    BASE_ROOT: '/' + baseRoot + '/app/',
    REST_ROOT: '/' + baseRoot + '/services/api-',
    CABEL_CUSTOMER: '/MSF-CUSTOMERDATA-MF/api/',
    REST_CUSTOMER: '/' + baseRoot + '/services/api-',
    COMPONENTS_PATH: 'components/',
    MOCK_ROOT: '/' + baseRoot + '/app/mocks/',
    MOCK_REST: {
      MENU: 'menu.json',
      RACCOMANDAZIONI: 'listaRaccomandazioni.json',
      PROPOSTE: 'listaProposte.json',
      LISTA_DOSSIER: 'listaDossier.json',
      LISTA_RICHIESTE: 'listaRichiesteOrdine.json',
      SALDO_PORTAFOGLIO: 'listaPortafoglio.json',
      TIPOLOGIA_STRUMENTO: 'tipologiaStrumento.json',
      CHECK_RACCOMANDAZIONE: 'checkRaccomandazione.json',
      STATO_RACCOMANDAZIONE: 'statoRaccomandazione.json',
      INSERISCI_RACCOMANDAZIONE: 'inserisciRaccomandazione.json',
      INSERISCI_PROPOSTA: 'inserisciProposta.json',
      LISTA_RICHIESTE2: 'listaRichieste.json'
    },

    FUNA: {},

    STATO_RACCOMANDAZIONE: {
      ND: 'ND',
      BOZZA: 'BOZZA',
      CONSOLIDATA: 'CONSOLIDATA',
      PRESENTATA: 'PRESENTATA',
      DA_REVISIONARE: 'DAREVISIONARE',
      ACCETTATA: 'ACCETTATA',
      RIFIUTATA: 'RIFIUTATA',
      ANNULLATA: 'ANNULLATA',
      PRE_CONTRATTO: 'PRECONTRATTO',
      VALIDATA: 'VALIDATA',
      FINANZIATA: 'FINANZIATA',
      IN_CORSO: 'INCORSO',
      DEFINITA: 'DEFINITA',
      PLAFOND: 'PLAFOND',
      DAPAGARE: 'DAPAGARE',
      CONCLUSA: 'CONCLUSA',
      SOSPESA: 'SOSPESA',
      IN_DELIBERA_PAC: 'INDELIBERAPAC',
      IN_PRE_DELIBERA_PAC: 'INPREDELIBERAPAC',
      APPROVAZIONE_DEROGA: 'APPROVAZIONEDEROGA',
      CONTRO_PROPOSTA_DEROGA: 'CONTROPROPOSTADEROGA'
    },

    TIPO_RACCOMANDAZIONE: {
      INSERIMENTO: 'INSERIMENTO'
    },

    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        FUNA: 'generale/funa',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        DOMAIN: 'generale/dominio'
      },
      WORKFLOW: {},
      DOCUMENTI_SERVICE: {},
      MENU: 'generale/menu',
      DOSSIER: 'dossier/',
      RACCOMANDAZIONE: 'raccomandazione/',
      PROPOSTA: 'proposta/',
      STRUMENTO: 'strumento/',
      ANAGRAFICA: 'anagrafica/',
      RICHIESTA: 'richiesta/',
      PARAMETRI: 'parametri/',
      CUSTOMER_DOSSIER: 'strumento/getDossier',
      RICONTRATTUALIZZAZIONE_DOSSIER: 'dossier/ricontrattualizzazione/',
      COMPOSIZIONE: 'dossier/GetDossierComposition',
      MOVEMENTS: 'portafoglio/ricercaDettaglioMovimenti',
      CHART: 'portafoglio/ricercaSaldiPeriodo',
      PORTAFOGLIO: 'portafoglio/recuperaEstrattoContoFiscale',
      TOTALI_CONTI: 'portafoglio/ricercaTotaliConti',
      REPORT: 'report',
      CUT_OFF: 'richiesta/bloccoOrdine'
    },

    MODALITA: {
      VISUALIZZA: 'visualizza',
      MODIFICA: 'modifica',
      NUOVA: 'nuova',
      VALUTAZIONE: 'valutazione'
    }
  });
})(window);



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.constants.js
 ** module id = 2
 ** module chunks = 0 1
 **/